import { CursorPaginatedResponseSchema, DefaultCursorPageSchema, isDefined } from 'notable-common';
import { z } from 'zod';
/** No `sort`: results come back newest first. */
export const EhrInformationListQuerySchema = z
    .object({
    mrn: z
        .string()
        .min(1)
        .max(100)
        .optional()
        .describe('Return only records with exactly this MRN.'),
    // An empty array would serialize to no parameter at all, and so ask for every record.
    ids: z
        .union([z.uuid(), z.array(z.uuid()).min(1).max(100)])
        .optional()
        .describe('Return only these records, such as the id in a staff patient link.'),
    organizationIds: z
        .union([z.uuid(), z.array(z.uuid()).min(1).max(50)])
        .optional()
        .describe('Return only records in practices of these organizations.'),
    page: DefaultCursorPageSchema,
})
    .strict()
    .refine((query) => isDefined(query.mrn) || isDefined(query.ids), {
    message: 'mrn or ids is required',
});
export const EhrInformationListEntrySchema = z.object({
    id: z.uuid().describe('The ehrInformationId other reads filter a patient record by.'),
    mrn: z.string(),
    practiceId: z.uuid(),
    created: z.iso.datetime(),
});
export const EhrInformationListResponseSchema = CursorPaginatedResponseSchema(EhrInformationListEntrySchema);
//# sourceMappingURL=list.js.map